export enum ControlDepartment {
  "1.- Plant/EDC" = 1,
  "2.- Central FTL" = 2,
  "3.- ODC Mgt" = 3,
  "4.- Plant/EDC" = 4,
  "5.- CCT" = 5,
  "6.- LTL to Plant" = 6,
  "7.- Jit/Kanban" = 7,
  "8.- Rail" = 8,
  "9.- Other" = 9,
  "10.- Non LLP" = 10,
  "-" = 11,
}

export const controlDepartmentAsString = new Map([
  [ControlDepartment["1.- Plant/EDC"], "1.- Plant/EDC"],
  [ControlDepartment["2.- Central FTL"], "2.- Central FTL"],
  [ControlDepartment["3.- ODC Mgt"], "3.- ODC Mgt"],
  [ControlDepartment["4.- Plant/EDC"], "4.- Plant/EDC"],
  [ControlDepartment["5.- CCT"], "5.- CCT"],
  [ControlDepartment["6.- LTL to Plant"], "6.- LTL to Plant"],
  [ControlDepartment["7.- Jit/Kanban"], "7.- Jit/Kanban"],
  [ControlDepartment["8.- Rail"], "8.- Rail"],
  [ControlDepartment["9.- Other"], "9.- Other"],
  [ControlDepartment["10.- Non LLP"], "10.- Non LLP"],
  [ControlDepartment["-"], "-"],
]);
